import { type FC, useState } from "react";
import {
  Chip,
  Flex,
  GalleryCarousel,
  Image,
  Modal,
  Text,
  Tooltip,
} from "@huub-web/ui";
import { toHumanCase } from "@huub-web/utils";

import type { AnalysisObservation } from "../../../types";
import { Tip } from "../../Tip";

import {
  containerStyle,
  imageContainerStyle,
  imageStyle,
} from "./AnalysisListItem.css";
import { firstLetterCapitalStyle } from "../AnalysisObservations.css";

export type AnalysisListItemProps = {
  observation: AnalysisObservation;
  alternate?: boolean;
};

/**
 * @deprecated
 */
export const AnalysisListItem: FC<AnalysisListItemProps> = ({
  observation,
  alternate = false,
}) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const media = observation.resolvedMediaReferences?.filter(
    (media) => !!media.url,
  );

  return (
    <>
      <Flex
        direction="column"
        gap="s"
        className={containerStyle({ alternate })}
      >
        <Flex gap="s" justify="space-between">
          <Flex direction="column" gap="xs">
            <Flex gap="s" align="center">
              <Text variant="bodyL" bold className={firstLetterCapitalStyle}>
                {observation.component?.replace(/_/g, " ")}
              </Text>
              <Chip variant="tertiary" className={firstLetterCapitalStyle}>
                {observation.assessment?.replace(/_/g, " ")}
              </Chip>
            </Flex>
            <Text markdown>{observation.explanation}</Text>
          </Flex>

          {media && media.length > 0 && (
            <div className={imageContainerStyle}>
              <Tooltip value="Relevante media">
                <Image
                  onClick={() => setIsModalOpen(true)}
                  className={imageStyle}
                  borderRadius
                  src={media[0].url ?? ""}
                  alt={media[0].reference ?? ""}
                />
              </Tooltip>
            </div>
          )}
        </Flex>
        {observation.improvementAdvice && (
          <Tip name="Advies">{observation.improvementAdvice}</Tip>
        )}
      </Flex>

      {isModalOpen && (
        <Modal
          escape
          closeable
          onClose={() => setIsModalOpen(false)}
          title={
            <Flex gap="s" align="center">
              <Text variant="bodyL" bold>
                {toHumanCase(observation.component)}
              </Text>
              <Chip variant="tertiary">{observation.assessment}</Chip>
            </Flex>
          }
        >
          {media && media.length > 0 && (
            <GalleryCarousel
              items={observation.resolvedMediaReferences
                .filter((media) => !!media.url)
                .map(({ url, reference }) => ({
                  url: url ?? "",
                  reference,
                }))}
            />
          )}
          <Flex direction="column" gap="xs">
            <Text variant="bodyS" markdown>
              {observation.explanation}
            </Text>
          </Flex>
          {observation.improvementAdvice && (
            <Tip name="Advies">{observation.improvementAdvice}</Tip>
          )}
        </Modal>
      )}
    </>
  );
};
